import getters from './getters'
import mutations from './mutations'
import { IState } from './types'

const state: IState = {
  loadingInputs: [],
}

export default {
  state,
  getters,
  mutations,
}
